// extracted by mini-css-extract-plugin
export default {"container":"topIndustryPlayers_container__Rf-5I","item":"topIndustryPlayers_item__Q3oHz"};